const digest = '6eaedecfaf0c76607489dcbc4f76972279da77f3c48a8fc03f1a4530b1b62d7d';
const css = `/* This is the height of Guided Setup. Hopefully this is temporary.
 * The browser cannot currently know the height of Guided Setup until the module has been
 * loaded AND its necessary data has been loaded. This takes too long and results in the modal
 * shifting in size until the data is loaded unless we set the size immediately.
 * On a related note, the Guided Setup fits with the standard max widths of the DLS modal. */
._magicHeight_1y9ju_6 {
  height: 782px;
}
@media (max-height: 874px) {
  ._magicHeight_1y9ju_6 {
    position: fixed !important;
    height: calc(100dvh - 47px);
    max-height: 782px;
    margin: 0;
    top: 47px;
    bottom: 0;
  }
}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'magicHeight': '_magicHeight_1y9ju_6' };
export const magicHeight = '_magicHeight_1y9ju_6';
export { css, digest };